import {Directive, ElementRef, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import { CmsContentSlot } from '@kion/data-models';
import { ActivatedRoute } from '@angular/router';

@Directive({
  selector: '[kionCmsSlot]'
})
export class CmsSlotDirective implements OnInit, OnChanges{

  @Input() component: CmsContentSlot;
  @Input() isSmartEdit: boolean = true;

  constructor(
    private element: ElementRef,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    if (this.route.snapshot.url.find(url => url.path === 'cx-preview')) {
      this.isSmartEdit = true
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.component){
      if (changes.component.currentValue !== changes.component.previousValue && this.isSmartEdit) {
        this.component = changes.component.currentValue;
        if (this.component?.properties?.smartedit && this.element.nativeElement) {
          this.element.nativeElement.setAttribute(
            'data-smartedit-catalog-version-uuid',
            this.component.properties.smartedit.catalogVersionUuid
          );
          this.element.nativeElement.setAttribute(
            'data-smartedit-component-type',
            this.component.properties.smartedit.componentType
          );
          this.element.nativeElement.setAttribute(
            'data-smartedit-component-id',
            this.component.properties.smartedit.componentId
          );
          this.element.nativeElement.setAttribute(
            'data-smartedit-component-uuid',
            this.component.properties.smartedit.componentUuid
          );
          this.element.nativeElement.setAttribute(
            'class',
            this.component.properties.smartedit.classes
          );
        }
      }
    }
  }
}
